import { CoreAppState } from '../state/core-app.state';
import { BaseResourceService } from './base-resource.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Thread } from '@prisma/client';
import { ThreadResourceTypeMappings } from '@aa/nest/resource';
import { threadCompositeKeyOrder } from '@aa/nest/resource/objects';

@Injectable()
export class ThreadService extends BaseResourceService<ThreadResourceTypeMappings> {
  constructor(
    protected override readonly http: HttpClient,
    protected override readonly store: Store<CoreAppState>,
  ) {
    super(http, store, 'threads');
  }
}
